export default __webpack_public_path__ + "static/media/Etape-10_MARAÎCHÈRE_DEF.4c12bc5a.mp3";